"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.InputSlider = exports.Container = exports.SliderProgress = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _typography = require("@creditas-lab/typography");

var _inputSlider = require("@creditas-lab/input-slider");

var _styledTools = require("styled-tools");

var sliderProgress = function sliderProgress(props) {
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  height: 100%;\n  width: ", ";\n  min-width: 43px;\n  background: ", ";\n\n  ", "\n"])), (0, _styledTools.prop)('progress.mobile')(props), (0, _styledTools.theme)('colorBrandPrimaryLight')(props), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    min-width: 75px;\n    width: ", ";\n  "])), (0, _styledTools.prop)('progress.desktop')(props)));
};

var SliderProgress = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), sliderProgress);

exports.SliderProgress = SliderProgress;

var Container = _stylitas.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n"])));

exports.Container = Container;
var InputSliderStyled = (0, _stylitas.styled)(_inputSlider.InputSlider)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 40px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-top: 52px;\n  "]))));
exports.InputSlider = InputSliderStyled;
var Description = (0, _stylitas.styled)(_typography.Typography)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: center;\n  color: ", ";\n"])), (0, _styledTools.theme)('colorFontNeutral60'));
exports.Description = Description;